// Disable specific eslint rule on next line since this module can have more exports in the future
// eslint-disable-next-line import/prefer-default-export
export function formSubmit({ action, method = 'post', fields }) {
  const form = document.createElement('form');

  form.setAttribute('method', method);
  form.setAttribute('action', action);

  for (const k in fields) {
    const input = document.createElement('input');
    input.setAttribute('name', k);
    input.setAttribute('value', fields[k]);
    form.appendChild(input);
  }

  const metaToken = document.querySelector('meta[name="csrf-token"]');

  if (metaToken) {
    const csrfToken = metaToken.getAttribute('content');

    const csrfTokenEl = document.createElement('input');
    csrfTokenEl.setAttribute('name', 'authenticity_token');
    csrfTokenEl.setAttribute('value', csrfToken);
    form.appendChild(csrfTokenEl);
  } else if (method === 'post') {
    console.warn(
      'Form submit with method=post but CSRF token could not be found. Submitting anyways...',
    );
  }

  document.body.appendChild(form);
  form.submit();
}
